export function createAdBreakObject(
  adbreakName: string,
  podIndex: number,
  adbreakCurrentTime: number
) {
  return {
    'media.ad.podFriendlyName': adbreakName,
    'media.ad.podIndex': podIndex,
    'media.ad.podSecond': adbreakCurrentTime,
  };
}
